@if (!blocked) {
  <ul class="space-y-5">
    <li>
      <parkour-deel-details-item
        description="Je teamlid kan jouw profiel lezen en je team zien"
        icon="people-group"
        title="Profiel en team"
      />
    </li>
    <li>
      <parkour-deel-details-item
        description="Gebeurtenissen die gedeeld zijn lezen"
        icon="compass"
        title="Verhaal"
      />
    </li>
    <li>
      <parkour-deel-details-item
        description="Doelen die gedeeld zijn lezen"
        icon="target"
        title="Doelen"
      />
    </li>
    <li>
      <parkour-deel-details-item
        description="Berichten sturen en reageren"
        icon="paper-plane"
        title="Berichten en reacties"
      />
    </li>
  </ul>
}

@if (blocked) {
  <parkour-deel-details-item
    data-testid="blocked-indicator"
    description="Je teamlid heeft geen toegang tot jouw profiel en team, verhaal, doelen en berichten. Als je teamlid terug actief is, kan die alles wat met hen gedeeld is terug zien."
    icon="block"
    title="Geblokkeerd"
  />
}
<!-- TODO: UX Copy profiel delen aan JSON toevoegen -->
